import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  type ElementRef,
  NgZone,
  OnDestroy,
  Renderer2,
  ViewChild,
  inject,
} from "@angular/core";

import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { IonContent, IonicModule } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject, Observable, Subject, of } from "rxjs";
import { switchMap, takeUntil } from "rxjs/operators";

//Services
import { StyleService } from "@providers/StyleService";
import { UrlsService } from "@providers/UrlsService";
import { SportService } from "@sports-services/index";
import { TicketService } from "@sports-services/index";
import { SportBookService } from "@sports-services/index";

import { EventsService } from "@providers/EventsService";
import { ScriptService } from "@providers/ScriptService";
import { NewBaseService } from "@providers/newBase.service";
import { IonLoaderService } from "@services/loader-feature/ion-loader.service";
import { SportNavigationService } from "@sports-services/index";

// Stores
import { NewTicketFacade, ticketState } from "@sports-features/ticket/stores";
import * as ticketSelector from "@sports-features/ticket/stores/ticket.selectors";
import { DeviceService } from "../../../../shared/services/device.service";

import { SportsCommonService } from "@sports-services/index";
import { SportsbookFacade } from "@sports-stores/sportsbook/sportsbook.facade";
import { SportsbookState } from "@sports-stores/sportsbook/sportsbook.reducers";
import * as sportsbookSelector from "@sports-stores/sportsbook/sportsbook.selectors";

//Models
import { GlobalVarsModel } from "@models/ModelGlobalsVar";
import { BetSenseData } from "@sports-models/betsense-data.model.deprecated";
import { DropdownMode, I_BetSenseModel, MarketParams, ScoreBoard } from "@sports-models/index";

// Pipes and directives
import { SportsExtractDatePipe } from "@sports-pipes/index";

// Directives
import { SportsBetDisplayDirective } from "@sports-directives/bet-display/bet-display";

// Components
import { CodereFooterComponent } from "@components/mso/footer/codere-footer/codere-footer";
import {
  BetbuilderComponent,
  SbButtonComponent,
  SbDropdownComponent,
  SbGridContentSingleComponent,
  SbGridHeaderComponent,
  SbGridItemComponent,
  SbMarqueeBetSenseComponent,
  SbPrematchScoreboardComponent,
  SbSimpleNavbarComponent,
  SbTabsCategoriesComponent,
  SportsBetButtonComponent,
  SportsBetButtonWrapperColumnComponent,
  SportsGridComponent,
  SportsGridContentSingleComponent,
  SportsGridContentTeamsComponent,
  SportsGridHelperComponent,
  SportsGroupComponent,
} from "@sports-components/index";

//Others
import { SPORTS_PATHS } from "@shared-constants/routes";
import { SportsBasePage, TrackingInfo } from "@sports-pages/index";
import { SmartLineItem, SmartMarketInput, createSmartLineItem } from "@sports-pages/ticket/models";
import { TicketItemTypesEnum } from "@sports-pages/ticket/utils/ticket.constants";
import { existsIn } from "@sports-services/sports.navigation.service/sports.navigation.utils";
import { Utils } from "@sports-utils/Utils";
import { SportHandleList, SportsConstants } from "@sports-utils/index";
import { PrincipalesCategoryId, ResultadosFinalesGameTypes } from "@sports-utils/sports.constants";

declare const SIR;

@Component({
  selector: "page-market",
  templateUrl: "./market.page.html",
  styleUrls: ["./market.page.scss"],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    SbSimpleNavbarComponent,
    SbPrematchScoreboardComponent,
    SbDropdownComponent,
    SbGridHeaderComponent,
    SbGridItemComponent,
    SbButtonComponent,
    SbGridContentSingleComponent,
    CodereFooterComponent,
    BetbuilderComponent,
    SportsBetDisplayDirective,
    SbMarqueeBetSenseComponent,
    SbTabsCategoriesComponent,
    SportsGroupComponent,
    SportsBetButtonComponent,
    SportsGridComponent,
    SportsGridContentTeamsComponent,
    SportsGridContentSingleComponent,
    SportsBetButtonWrapperColumnComponent,
    SportsGridHelperComponent,
  ],
})
export class MercadosPage extends SportsBasePage implements OnDestroy, AfterViewInit {
  @ViewChild(IonContent) content: IonContent;
  @ViewChild("standardWidgetSIR") standardWidgetSIR: ElementRef;
  @ViewChild("stickyWidgetSIR") stickyWidgetSIR: ElementRef;
  @ViewChild("standardWidgetSIR2") standardWidgetSIR2: ElementRef;
  @ViewChild("stickyWidgetSIR2") stickyWidgetSIR2: ElementRef;
  market: any;
  marketBets$ = [];
  currentCategory$ = new BehaviorSubject(null);
  categories: any[] = [];
  scoreboard: ScoreBoard;
  offset = 0;
  eventListener: any;
  widgetActive: string;
  gametypes = ResultadosFinalesGameTypes;

  betbuilderSelection$: Observable<SmartLineItem[]>;
  betbuilderSelection: any[] = [];
  smartMarketRequest: SmartMarketInput;
  betbuilderCuotaText: string = "";
  betbuilderMessageText: string = SportsConstants.AnadirAlMenosXSelecciones;
  betbuilderErrorMessage: string = "";

  isDesktop = false;
  isMobile = false;

  globalVars: GlobalVarsModel;
  extractDate = inject(SportsExtractDatePipe);
  sportBookService = inject(SportBookService);
  newTicketFacade = inject(NewTicketFacade);
  sportService = inject(SportService);
  ticketService = inject(TicketService);
  translate = inject(TranslateService);
  urlsService = inject(UrlsService);
  styleService = inject(StyleService);
  scriptService = inject(ScriptService);
  renderer = inject(Renderer2);
  ngZone = inject(NgZone);
  utils = inject(Utils);
  newBaseService = inject(NewBaseService);
  ionLoaderService = inject(IonLoaderService);
  sportsbookFacade = inject(SportsbookFacade);

  dropdownMode = DropdownMode;
  deviceService = inject(DeviceService);
  eventService = inject(EventsService);
  ticketsStore = inject(Store<ticketState>);
  sportsbookStore = inject(Store<SportsbookState>);
  router = inject(Router);
  sportNavigationService = inject(SportNavigationService);
  sportCommonService = inject(SportsCommonService);

  betbuilderCatId = SportsConstants.betbuilderCatId;

  marketData$: Observable<any>;

  selectedMarket: MarketParams;

  //* BETSENSE
  betSenseData: BetSenseData = new BetSenseData();
  betsenseData = [];

  //restore
  firstIterationRestore = false;
  sportsNavigationId = undefined;

  stateToSave = {
    category: undefined,
    scrollPosition: undefined,
  };
  stateToRestore = undefined;
  isDeepLink = false;

  private ngUnsubscribe$ = new Subject<boolean>();

  constructor() {
    super();

    this.isDesktop = this.deviceService.isDesktop();
    this.isMobile = this.deviceService.isMobile();

    const currentUrl = this.sportNavigationService.navigationState$.getValue().currentUrl;
    this.sportsNavigationId = currentUrl.state.sportsNavigationId;
    this.selectedMarket = {
      ...currentUrl.state.params,
      SportHandleLiteral: SportHandleList[`${currentUrl.state.params.SportHandle}Literal`],
    };
    if (!this.selectedMarket.teamHome || !this.selectedMarket.teamAway) {
      const nameSplited = this.selectedMarket.Name.split("-");
      this.selectedMarket = {
        ...this.selectedMarket,
        teamHome: nameSplited?.[0]?.trim(),
        teamAway: nameSplited?.[1]?.trim(),
      };
    }
    this.isDeepLink = !!currentUrl.url.split("?")[1];
    this.initializePage();

    this.betbuilderSelection$ = this.ticketsStore.select(ticketSelector.getBetbuilderSelection);
    this.betbuilderSelection$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((betbuilderSelection: any) => {
      this.betbuilderSelection = betbuilderSelection;
      this.checkBetbuilderLength();
    });

    this.marketData$ = this.sportsbookStore.select(sportsbookSelector.getMarketDataState);
    this.marketData$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((marketData) => {
      this.categories = marketData.categories;

      this.currentCategory$.next(marketData.selectedCategory);
      this.marketBets$ = marketData.marketBets;
      if (marketData.betsenseData) {
        this.betsenseData = this.setBetSenseData(marketData.betsenseData);
      }
      const currentUrl = this.sportNavigationService.navigationState$.getValue().currentUrl;
      if (currentUrl?.popstate && marketData.categories && !this.firstIterationRestore) {
        this.sportsNavigationId = currentUrl.state.sportsNavigationId;
        this.stateToRestore = this.sportNavigationService.getRestoreStateFromHistory(this.sportsNavigationId);
        if (this.stateToRestore) {
          this.tryRestoreCategory(marketData.categories);
          this.stateToSave = this.stateToRestore;
        }
        this.firstIterationRestore = true;
      }
      const isNowLive = marketData?.marketBets[0]?.IsLive;

      if (isNowLive) {
        const params = {
          parentId: this.selectedMarket.ParentNodeId,
          categoryInfoId: PrincipalesCategoryId,
          sportHandle: this.selectedMarket.SportHandle,
          leagueName: this.selectedMarket.LeagueName,
        };
        this.router.navigate([SPORTS_PATHS.NowLiveDetailPage], {
          state: { params },
        });
      }

      if (!this.sportBookService.canCreateBetbuilder(marketData, "market")) {
        this.betbuilderErrorMessage = this.translate.instant("SPO_BetbuilderNotAvailable");
        this.marketBets$ = [];
      } else {
        this.betbuilderErrorMessage =
          this.betbuilderErrorMessage === this.translate.instant("SPO_BetbuilderNotAvailable")
            ? ""
            : this.betbuilderErrorMessage;
      }
    });
  }

  tryRestoreCategory(categories) {
    if (this.stateToRestore.category && existsIn(this.stateToRestore.category, categories, "CategoryId")) {
      this.changeCategory(this.stateToRestore.category);
    }
    setTimeout(() => {
      this.content.scrollToPoint(undefined, this.stateToRestore.scrollPosition || 0, 250);
    }, 150);
  }

  initializePage() {
    this.sportsbookFacade.getMarketData(this.selectedMarket);
    this.newBaseService.getVars
      .pipe(
        switchMap((data: GlobalVarsModel) => {
          this.globalVars = data;
          return of(null);
        }),
      )
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe();
    const trackingInfo: TrackingInfo = this.getTrackingInfo();
    if (trackingInfo != null) {
      this.trackPageView(trackingInfo);
    }
    this.scoreboard = new ScoreBoard(
      this.selectedMarket.teamHome,
      this.selectedMarket.teamAway,
      this.selectedMarket.StartDate,
      this.selectedMarket.pitcherHome ? this.selectedMarket.pitcherHome : null,
      this.selectedMarket.pitcherAway ? this.selectedMarket.pitcherAway : null,
    );
    this.trackingService.trackEvent([
      "SelectMarket",
      this.selectedMarket.NodeId,
      this.selectedMarket.SportHandle,
      this.selectedMarket.Name,
      "pageView",
    ]);
    window.addEventListener("message", this.eventListener);
  }

  ngAfterViewInit() {
    if (this.showSportRadar()) {
      Promise.all([this.scriptService.load("sportradar"), this.styleService.load("sportradar")]).then(() => {
        this.sportService.showSportradar$.next(true);
        this.sportService.eventStatisticsId$.next(this.selectedMarket.StatisticsId);
        this.sportService.isFormula1$.next(false);
        if (this.isMobile) {
          this.widgetActive = "standard";
          this.setSportRadarWidget();
        }
      });
    }
    if (this.showFormula1()) {
      Promise.all([this.scriptService.load("sportradarF1"), this.styleService.load("sportradar")]).then(() => {
        this.sportService.showSportradar$.next(true);
        this.sportService.eventStatisticsId$.next(this.selectedMarket.StatisticsId);
        this.sportService.isFormula1$.next(true);
        if (this.isMobile) {
          this.widgetActive = "standard";
          this.setSportRadarWidgetF1();
        }
      });
    }
  }

  setBetSenseData(betSenseData) {
    const betsenseItems: I_BetSenseModel[] = [];
    betSenseData.forEach((betSenseDataItem) => {
      const NodeId = betSenseDataItem.outcomes.find(
        (item) => item.label === betSenseDataItem.delivery.es.log.cta_target,
      ).id;
      const ParentNodeId = betSenseDataItem.data.offer.id;
      let odd;
      const marketBetGroup = this.marketBets$.find((bet) => bet.NodeId === ParentNodeId);
      if (marketBetGroup) {
        odd = marketBetGroup.GroupResults.find((gr) => gr.NodeId === NodeId).Odd;
      } else {
        odd = betSenseDataItem.data.offer.outcomes.find((i) => i.id === NodeId).oddsDecimal;
      }
      betsenseItems.push({
        title: betSenseDataItem.delivery?.es?.log?.body,
        Name: betSenseDataItem.delivery?.es?.log?.cta,
        Odd: odd,
        marketName: betSenseDataItem.data?.offer?.name,
        NodeId,
      });
    });
    return betsenseItems.filter((item, index, self) => index === self.findIndex((t) => t.NodeId === item.NodeId));
  }

  onScroll(event) {
    this.updateLastStateToRestore(undefined, event.detail.scrollTop);
    if ((!this.showSportRadar() && !this.showFormula1()) || !event) {
      return;
    }
    if (event.detail.scrollTop > 0) {
      this.widgetActive = "sticky";
      if (this.standardWidgetSIR !== undefined)
        this.renderer.addClass(this.standardWidgetSIR.nativeElement, "d-none");
      if (this.stickyWidgetSIR !== undefined)
        this.renderer.removeClass(this.stickyWidgetSIR.nativeElement, "d-none");
      if (this.standardWidgetSIR2 !== undefined)
        this.renderer.addClass(this.standardWidgetSIR2.nativeElement, "d-none");
      if (this.stickyWidgetSIR2 !== undefined)
        this.renderer.removeClass(this.stickyWidgetSIR2.nativeElement, "d-none");
    } else {
      this.widgetActive = "standard";
      if (this.standardWidgetSIR !== undefined)
        this.renderer.removeClass(this.standardWidgetSIR.nativeElement, "d-none");
      if (this.stickyWidgetSIR !== undefined) this.renderer.addClass(this.stickyWidgetSIR.nativeElement, "d-none");
      if (this.standardWidgetSIR2 !== undefined)
        this.renderer.removeClass(this.standardWidgetSIR2.nativeElement, "d-none");
      if (this.stickyWidgetSIR2 !== undefined)
        this.renderer.addClass(this.stickyWidgetSIR2.nativeElement, "d-none");
    }
  }

  setSportRadarWidget() {
    this.renderer.addClass(this.stickyWidgetSIR.nativeElement, "d-none");
    SIR(
      "addWidget",
      ".sr-widget-1",
      "match.lmtSticky",
      {
        layout: "topdown",
        scoreboard: "disable",
        detailedScoreboard: "disable",
        tabsPosition: "top",
        matchId: this.selectedMarket.StatisticsId,
        onTrack: this.sportCommonService.onTrackSportRadarErrorLogger,
        silent: true,
      },
      () =>
        setTimeout(() => {
          this.content.scrollToTop();
        }, 500),
    );
    SIR(
      "addWidget",
      ".sr-widget-2",
      "match.lmtPlus",
      {
        layout: "single",
        scoreboard: "disable",
        detailedScoreboard: "disable",
        tabsPosition: "top",
        pitchLogo: "./assets/global/img/codere-apuestas-mx.svg",
        goalBannerImage: "./assets/global/img/codere_green.svg",
        logo: ["./assets/global/img/codere_grey.svg"],
        matchId: this.selectedMarket.StatisticsId,
        onTrack: this.sportCommonService.onTrackSportRadarErrorLogger,
        silent: true,
      },
      () =>
        setTimeout(() => {
          this.content.scrollToTop();
        }, 500),
    );

    this.renderer.listen(this.stickyWidgetSIR.nativeElement, "click", () => {
      this.widgetActive = "standard";
      this.renderer.addClass(this.stickyWidgetSIR.nativeElement, "d-none");
      this.renderer.removeClass(this.standardWidgetSIR.nativeElement, "d-none");
    });
  }

  setSportRadarWidgetF1() {
    this.renderer.addClass(this.stickyWidgetSIR2.nativeElement, "d-none");
    SIR(
      "addWidget",
      ".sr-widget-1",
      "match.lmtSticky",
      {
        layout: "topdown",
        scoreboard: "disable",
        detailedScoreboard: "disable",
        tabsPosition: "top",
        stageId: this.selectedMarket.StatisticsId,
        onTrack: this.sportCommonService.onTrackSportRadarErrorLogger,
        silent: true,
      },
      () =>
        setTimeout(() => {
          this.content.scrollToTop();
        }, 500),
    );
    SIR(
      "addWidget",
      ".sr-widget-2",
      "match.lmtPlus",
      {
        layout: "single",
        scoreboard: "disable",
        detailedScoreboard: "disable",
        tabsPosition: "top",
        pitchLogo: "./assets/global/img/codere-apuestas-mx.svg",
        goalBannerImage: "./assets/global/img/codere_green.svg",
        logo: ["./assets/global/img/codere_grey.svg"],
        stageId: this.selectedMarket.StatisticsId,
        onTrack: this.sportCommonService.onTrackSportRadarErrorLogger,
        silent: true,
      },
      () =>
        setTimeout(() => {
          this.content.scrollToTop();
        }, 500),
    );

    this.renderer.listen(this.stickyWidgetSIR2.nativeElement, "click", () => {
      this.widgetActive = "standard";
      this.renderer.addClass(this.stickyWidgetSIR2.nativeElement, "d-none");
      this.renderer.removeClass(this.standardWidgetSIR2.nativeElement, "d-none");
    });
  }

  getTrackingInfo(): TrackingInfo {
    return {
      uri: encodeURI(
        `/${this.selectedMarket.SportHandle}/${this.selectedMarket.LeagueName}/nonLive/${this.selectedMarket.Name}`,
      ),
      description: `Mercados page - ${this.selectedMarket.Name}`,
      additionalData: {
        nodeId: this.selectedMarket.NodeId,
        nodeName: this.selectedMarket.Name,
        sportHandle: this.selectedMarket.SportHandle,
        LeagueName: this.selectedMarket.LeagueName,
      },
    };
  }

  public showSportRadar() {
    return (
      (this.selectedMarket?.SportHandle === SportHandleList.soccer ||
        this.selectedMarket?.SportHandle === SportHandleList.tennis ||
        this.selectedMarket?.SportHandle === SportHandleList.basketball) &&
      this.selectedMarket?.LTMEnabled
    );
  }

  public showFormula1() {
    const showF1 =
      this.globalVars?.FEATURES.SPO_LMTFormula1 &&
      this.selectedMarket?.SportHandle === SportHandleList.motorsport &&
      !!this.selectedMarket?.StatisticsId;
    return showF1;
  }

  changeCategory(category) {
    this.content.scrollToTop();
    this.sportsbookFacade.setMarketSelectedCategory(category);
    this.updateLastStateToRestore(category, 0);
    // check if selected category is betbuilder
    if (this.isMobile) {
      if (category) {
        if (category.CategoryId === SportsConstants.betbuilderCatId) {
          this.widgetActive = "sticky";
          if (this.stickyWidgetSIR) {
            this.renderer.addClass(this.standardWidgetSIR.nativeElement, "d-none");
            this.renderer.removeClass(this.stickyWidgetSIR.nativeElement, "d-none");
          }
          if (this.stickyWidgetSIR2) {
            this.renderer.addClass(this.standardWidgetSIR2.nativeElement, "d-none");
            this.renderer.removeClass(this.stickyWidgetSIR2.nativeElement, "d-none");
          }
        } else {
          this.widgetActive = "standard";
          if (this.standardWidgetSIR) {
            this.renderer.removeClass(this.standardWidgetSIR.nativeElement, "d-none");
            this.renderer.addClass(this.stickyWidgetSIR.nativeElement, "d-none");
          }
          if (this.standardWidgetSIR2) {
            this.renderer.removeClass(this.standardWidgetSIR2.nativeElement, "d-none");
            this.renderer.addClass(this.stickyWidgetSIR2.nativeElement, "d-none");
          }
        }
      }
    }
  }

  transformGameDataForBet(gameData) {
    return {
      betItem: {
        Odd: gameData.Odd,
        SortOrder: gameData.SortOrder,
        IsLive: false,
        upOdd: false,
        downOdd: false,
        IsNonRunner: false,
        SportId: gameData.Parent.Parent.Parent.Parent.Parent.NodeId,
        LocationId: gameData.Parent.Parent.Parent.Parent.NodeId,
        LeagueId: gameData.Parent.Parent.Parent.NodeId,
        EventId: gameData.Parent.Parent.NodeId,
        EventHasHandicap: false,
        GameId: gameData.Parent.NodeId,
        GameTypeId: gameData.Parent.GameTypeId,
        GameSpecialOddsValue: "",
        GameBetTypeAvailability: 0,
        GameNumberOfStarters: 0,
        Name: gameData.NodeName,
        NodeId: gameData.NodeId,
        ParentNodeId: gameData.Parent.NodeId,
        Priority: 0,
        SportHandle: gameData.SportHandle,
        Locked: gameData.Locked,
        Spov: "",
      },
      gameGroup: {
        DisplayTypeName: gameData.Parent.DisplayTypeName,
        Name: gameData.Parent.NodeName,
        NodeId: gameData.Parent.NodeId,
        ParentNodeId: gameData.Parent.Parent.NodeId,
        GameType: gameData.Parent.GameTypeId,
        Priority: gameData.Parent.Priority,
        SportHandle: gameData.Parent.SportHandle,
        GroupResults: [],
        CategoryInfo: gameData.Parent.CategoryInfo,
        CategoryInfos: gameData.Parent.CategoryInfos,
        teamHome: gameData.Parent.Parent.ParticipantHome,
        teamAway: gameData.Parent.Parent.ParticipantAway,
        Spov: "",
        AllSpov: [""],
        SmartMarketAvailable: gameData.Parent.SmartMarketAvailable,
        nameLeague: gameData.Parent.Parent.Parent.NodeName,
        Locked: gameData.Locked,
        isCombined: gameData.IsCombinable,
      },
      name: gameData.Parent.NodeName,
    };
  }

  betSenseBet(NodeId) {
    const gameGroup = this.marketBets$.find((i) => i.GroupResults.find((gr) => gr.NodeId === NodeId));
    const betItem = this.marketBets$.flatMap((i) => i.GroupResults).find((gr) => gr.NodeId === NodeId);
    if (gameGroup && betItem) {
      this.bet(betItem, gameGroup, gameGroup.Name, "betSense");
    } else {
      this.sportService
        .getGameByNodeId(NodeId)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe((data) => {
          if (data) {
            const bet = this.transformGameDataForBet(data);
            this.bet(bet.betItem, bet.gameGroup, bet.name, "betSense");
          } else {
            this.utils.sportsAlert(
              true,
              "",
              this.translate.instant("marketNotAvailable"),
              this.translate.instant("tAccept"),
            );
          }
        });
    }
  }

  public bet(game: any, event: any, gameName: string, type: string, position: string = "") {
    let data = {
      ...game,
      EventDate: this.extractDate.transform(event.StartDate),
      EventName: this.selectedMarket.Name,
      GameName: gameName,
    };

    data = this.correctData(data, event, gameName, type, position);

    if (this.currentCategory$.value.CategoryId === SportsConstants.betbuilderCatId) {
      this.checkBetbuilderSelection(data, data.NodeId, game.GameTypeId);
    } else {
      this.newTicketFacade.checkSelection(data, data.NodeId, TicketItemTypesEnum.LINE_ITEM);
    }
  }

  checkBetbuilderSelection(data, nodeId, gameTypeId) {
    const id = this.betbuilderSelection.findIndex((item) => item.NodeId === nodeId);
    // remove
    if (id !== -1) {
      this.newTicketFacade.removeSmartMarketSelection(nodeId);
    } else {
      //add
      this.newTicketFacade.sendAddSmartMarketSelection(data);
    }
  }

  checkBetbuilderLength() {
    switch (this.betbuilderSelection.length) {
      case 0:
        this.betbuilderMessageText = this.translate.instant("SPO_BetbuilderMessage2"); // "Necesitas al menos 2 selecciones."; SPO_BetbuilderMessage2
        this.betbuilderCleanValues();
        break;
      case 1:
        this.betbuilderMessageText = this.translate.instant("SPO_BetbuilderMessage1"); // "Añadir al menos 1 o más selecciones."; SPO_BetbuilderMessage1
        this.betbuilderCleanValues();
        break;
      default:
        this.betbuilderMessageText = this.translate.instant("SPO_BetbuilderMessage"); // "Apostar o añadir más selecciones"; SPO_BetbuilderMessage
        this.betbuilderCheck();
        break;
    }
  }

  betbuilderCleanValues() {
    this.betbuilderCuotaText = "";
    this.betbuilderErrorMessage = "";
  }

  betbuilderCheck() {
    this.ionLoaderService.showHideAutoLoader();
    this.sportService
      .addSmartMarketItem(this.betbuilderSelection)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((resp) => {
        this.ionLoaderService.hideLoader();
        if (resp.Odds < 0) {
          this.betbuilderCuotaText = "";
          this.betbuilderErrorMessage = this.translate.instant("SPO_BetbuilderMessageError");
          this.smartMarketRequest = null;
        } else {
          this.betbuilderCuotaText = resp.Odds.toFixed(2).toString();
          this.betbuilderErrorMessage = "";
          this.smartMarketRequest = resp;
        }
      });
  }

  sendAddSmartMarketItem() {
    const smartMarketBet = createSmartLineItem(
      this.betbuilderSelection,
      this.selectedMarket,
      this.betbuilderCuotaText,
    );
    delete this.smartMarketRequest["MaxSystem"]; // ????
    this.newTicketFacade.sendAddSmartMarketItem(this.smartMarketRequest, smartMarketBet);
  }

  checkSelected(nodeId) {
    let selected = false;
    if (this.currentCategory$.value.CategoryId === SportsConstants.betbuilderCatId) {
      selected = this.betbuilderSelectionCheck(nodeId);
    } else {
      selected = this.newTicketFacade.hasResult(nodeId);
    }
    return selected;
  }

  betbuilderSelectionCheck(nodeId) {
    const nodeSelected = this.betbuilderSelection.filter((item) => item.NodeId === nodeId).length > 0;
    let selected = false;
    selected = this.currentCategory$.value.CategoryId === SportsConstants.betbuilderCatId && nodeSelected;

    return selected;
  }

  correctData(data: any, event: any, gameName: string, type: string, position: string) {
    switch (true) {
      case (gameName.includes("Handicap") || gameName.includes("Hándicap")) && type === "1" && position === "1":
        data.Name = `${this.selectedMarket.teamHome} ${data.Name}`;
        break;
      case (gameName.includes("Handicap") || gameName.includes("Hándicap")) && type === "1" && position === "X":
        data.Name = `X (${this.selectedMarket.teamAway} ${data.Name})`;
        break;
      case (gameName.includes("Handicap") || gameName.includes("Hándicap")) && type === "1" && position === "2":
        data.Name = `${this.selectedMarket.teamAway} ${data.Name}`;
        break;
      case gameName.includes(SportsConstants.GoalscorersLiteral) && position === "0":
        data.GameName = SportsConstants.GameTypesDefinitions.FirstGoalscorer.Literal;
        break;
      case gameName.includes(SportsConstants.GoalscorersLiteral) && position === "1":
        data.GameName = SportsConstants.GameTypesDefinitions.ScoreGoalDuringTheMatch.Literal;
        break;
      case gameName.includes(SportsConstants.GoalscorersLiteral) && position === "2":
        data.GameName = SportsConstants.GameTypesDefinitions.ScoreTwoOrMoreGoals.Literal;
        break;
    }
    return data;
  }

  getPosition(length: number, index: number) {
    let position = "";
    if (length % 3 === 0) {
      switch (true) {
        case index === 1:
        case index === 4:
        case index === 7:
          position = "X";
          break;
        case index === 2:
        case index === 5:
        case index === 8:
          position = "2";
          break;
        default:
          position = "1";
          break;
      }
    } else {
      switch (true) {
        case index === 1:
        case index === 3:
        case index === 5:
          position = "2";
          break;
        default:
          position = "1";
          break;
      }
    }
    return position;
  }

  removeSmartMarketSelections() {
    this.newTicketFacade.clearBetbuilderSelections();
  }

  public navigate(market): void {
    const component = market.isLive ? SPORTS_PATHS.NowLiveDetailPage : SPORTS_PATHS.MercadosPage;
    const eventType = market.isLive ? "pushEventLive" : "pushEvent";
    this.router.navigate([component], {
      state: { params: market },
      queryParams: { animate: !this.isDesktop },
    });

    this.trackingService.trackEvent([eventType, market.NodeId, window.location.hash, market.Name, "event"]);
  }

  unsuscribeToSubjects() {
    this.newTicketFacade.clearBetbuilderSelections();

    this.ngUnsubscribe$.next(true);
    this.ngUnsubscribe$.complete();
  }

  ngOnDestroy() {
    this.sportNavigationService.injectLastStateToHistory(this.sportsNavigationId, this.stateToSave);
    this.unsuscribeToSubjects();
    window.removeEventListener("message", this.eventListener);
    if (this.showSportRadar() && this.isMobile) {
      SIR("removeWidget", document.querySelector(".sr-widget-1"));
      SIR("removeWidget", document.querySelector(".sr-widget-2"));
    } else if (this.showSportRadar() && this.isDesktop) {
      this.sportService.showSportradar$.next(false);
      this.sportService.eventStatisticsId$.next("");
      this.sportService.isFormula1$.next(false);
    }

    if (this.globalVars.FEATURES.SPO_LMTFormula1 && this.showFormula1()) {
      this.sportService.showSportradar$.next(false);
      this.sportService.eventStatisticsId$.next("");
      this.sportService.isFormula1$.next(false);
    }

    this.removeSmartMarketSelections();
  }

  updateLastStateToRestore(category, scrollPosition) {
    const newStateToSave = {
      ...this.stateToSave,
    };
    if (category !== undefined) {
      newStateToSave.category = category;
    }
    if (scrollPosition !== undefined) {
      newStateToSave.scrollPosition = scrollPosition;
    }
    this.stateToSave = newStateToSave;
  }

  trackBy(_index, item) {
    return item.NodeId;
  }
}
